import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-customer-visits',
  templateUrl: './customer-visits.component.html',
  styleUrls: ['./customer-visits.component.css']
})
export class CustomerVisitsComponent implements OnInit {

  constructor(private customerService:ServiceService,private route: ActivatedRoute, private router: Router) { }
  //------function for routing-----------
  CustomerVisitDetails(){
    this.router.navigateByUrl(('admin/customer-visit-details'));  
  }
  
  //--------function which give id of selected customer---------
  getValue = (item : string) =>{
     
    this.customerService.setCustomerId(item)
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  
  }
  output:any=[];
 // getUrl='http://192.241.151.66:5000/viewVisit';
  //empUrl='http://192.241.151.66:5000/viewEmployees';
  //searchEmployeeUrl='http://192.241.151.66:5000/viewEmployees?employee_name='
  count=0;
  search:string='';
  employee:any=[];
  emp:any=[];
  employee_id=""
  searchEmployee:string='';
  isShownEmployee=false
  ApplayFlag=0
  loaderShown=false
  tableShown=true
  data1={
    from_date:"",
    to_date:"",
    employee_id:""
  }
  data2={
    from_date:"",
    to_date:""
  }

  data3={
    employee_id:""
  }
  
  data4={
    from_date:"",
    to_date:"",
    employee_id:"",
    emp_name:""
  }
  Total_Count="";
  admin_id=localStorage.getItem('admin_id')
//-------------function for search--------------------
SearchEmployee(){
  if(this.data4.emp_name!='')
  {
  this.isShownEmployee=true;
  }
  this.searchEmployee=this.data4.emp_name
  
  this.customerService.SearchEmployee(this.searchEmployee).subscribe((res)=>{
  this.employee=res.data
 
  })
}
//---------function for getting searched employee id---------------
getEmployeeId(value1:any,value2:any){
     
     this.isShownEmployee=false
     //this.searchEmployee=value2
     //this.employee_id=value1
     this.data4.emp_name=value2
     this.data4.employee_id=value1
     console.log("search result", this.data4.employee_id)
}

//function for going to next page
  clicks_next(){
    this.count=this.count+1;

    if(this.ApplayFlag==1 && this.data4.employee_id=="" && this.data4.from_date!="" && this.data4.to_date!="")
       {
         this.customerService.ViewVisit('?user_id='+this.admin_id+'&offset='+this.count+'&limit=20',this.data2).subscribe((res)=>{
         this.output=res.data
         this.Total_Count=res.total_count;
         console.log("1")
          })
       }
   //------call api without customer id field-------
   else if(this.ApplayFlag==1 && this.data4.employee_id!="" && this.data4.from_date!=""&&this.data4.to_date!="")
        {
           this.customerService.ViewVisit('?user_id='+this.admin_id+'&offset='+this.count+'&limit=20',this.data1).subscribe((res)=>{
           this.output=res.data
           this.Total_Count=res.total_count;
           
           console.log("2")
           })
         }
   else if(this.ApplayFlag==1 && this.data4.employee_id!="" && this.data4.from_date==""&&this.data4.to_date=="")
       {
         this.customerService.ViewVisit('?user_id='+this.admin_id+'&offset='+this.count+'&limit=20',this.data3).subscribe((res)=>{
         this.output=res.data
         this.Total_Count=res.total_count;
         console.log("3")
        })
       }
    else{
    //-------api get()calling for next page-------------
    this.customerService.GetVisit('?user_id='+this.admin_id+'&offset='+this.count+'&limit=20').subscribe((res)=>{
    this.output=res.data
    this.Total_Count=res.total_count;
    })
    }
  }
  
  //function for going to previous page
  clicks_previous(){
    this.count=this.count-1;
    if(this.count<0)
    {
      this.count=0
    }
    
    if(this.ApplayFlag==1 && this.data4.employee_id=="" && this.data4.from_date!="" && this.data4.to_date!="")
       {
         this.customerService.ViewVisit('?user_id='+this.admin_id+'&offset='+this.count+'&limit=20',this.data2).subscribe((res)=>{
         this.output=res.data
         this.Total_Count=res.total_count;
         console.log("1")
          })
       }
   //------call api without customer id field-------
   else if(this.ApplayFlag==1 && this.data4.employee_id!="" && this.data4.from_date!=""&&this.data4.to_date!="")
        {
           this.customerService.ViewVisit('?user_id='+this.admin_id+'&offset='+this.count+'&limit=20',this.data1).subscribe((res)=>{
           this.output=res.data
           this.Total_Count=res.total_count;
           
           console.log("2")
           })
         }
   else if(this.ApplayFlag==1 && this.data4.employee_id!="" && this.data4.from_date==""&&this.data4.to_date=="")
       {
         this.customerService.ViewVisit('?user_id='+this.admin_id+'&offset='+this.count+'&limit=20',this.data3).subscribe((res)=>{
         this.output=res.data
         this.Total_Count=res.total_count;
         console.log("3")
        })
       }
    else{ 
    //-------api get()calling for previous page-------------
    this.customerService.GetVisit('?user_id='+this.admin_id+'&offset='+this.count+'&limit=20').subscribe((res)=>{
    this.output=res.data
    this.Total_Count=res.total_count;
    })
    }
  }
 
  //-----function for applay button click-------//
  btnClick(){

  this.ApplayFlag=1;
  //------------timer---------------------
  this.tableShown=false
  this.loaderShown=true
  /*
  setTimeout(() => {
   this.loaderShown=false;
   this.tableShown=true
 }, 800);
 */
//--------------------------------------

   console.log("From=",this.data4.from_date)
   console.log("To=",this.data4.to_date)
    if(this.data4.emp_name=="")
    {
     this.data4.employee_id=""
    }
 
   this.count=0
   console.log(this.data4.employee_id)
    console.log(this.data4.emp_name)
 
   if(this.data4.employee_id=="" && this.data4.from_date!="" && this.data4.to_date!="")
       {
         console.log("empty employee field");
         this.data2.from_date=this.data4.from_date
         this.data2.to_date=this.data4.to_date
         this.customerService.ViewVisit('?user_id='+this.admin_id+'&offset='+this.count+'&limit=20',this.data2).subscribe((res)=>{
         this.output=res.data
         this.Total_Count=res.total_count;
         console.log("1")

         this.loaderShown=false;
         this.tableShown=true
         
          })
       }
   //------call api without customer id field-------
   else if(this.data4.employee_id!="" && this.data4.from_date!=""&&this.data4.to_date!="")
        {
           this.data1.from_date=this.data4.from_date
           this.data1.to_date=this.data4.to_date
           this.data1.employee_id=this.data4.employee_id
           this.customerService.ViewVisit('?user_id='+this.admin_id+'&offset='+this.count+'&limit=20',this.data1).subscribe((res)=>{
           this.output=res.data
           this.Total_Count=res.total_count;
           console.log("2")

           this.loaderShown=false;
           this.tableShown=true

           console.log(this.data1.employee_id)
           console.log("output=",this.output)
           
           })
         }
   else if(this.data4.employee_id!="" && this.data4.from_date==""&&this.data4.to_date=="")
       {
         this.data3.employee_id=this.data4.employee_id
         this.customerService.ViewVisit('?user_id='+this.admin_id+'&offset='+this.count+'&limit=20',this.data3).subscribe((res)=>{
         this.output=res.data
         this.Total_Count=res.total_count;
         console.log("3")

         this.loaderShown=false;
         this.tableShown=true

         console.log(this.data3.employee_id)
         console.log("output=",this.output)
        })
       }
     else{
 
       this.customerService.GetVisit("?user_id="+this.admin_id).subscribe((res)=>{
       this.output=res.data
       this.Total_Count=res.total_count;
       console.log("4")
       this.loaderShown=false;
       this.tableShown=true
       })
 
     }
  }
  ngOnInit(): void {

    this.tableShown=false
    this.loaderShown=true
   //-------api get()calling-------------
   this.customerService.GetVisit("?user_id="+this.admin_id).subscribe((res)=>{
   this.output=res.data
   this.Total_Count=res.total_count;

   this.loaderShown=false;
   this.tableShown=true
   console.log("customer details =",this.output)

  })
    //-------api for get emoployee name---------

    this.customerService.ViewEmployee().subscribe((res)=>{
      this.employee=res.data

    })
}
}


